<template>
  <div ref="maindiv" id="addeditcontent">

    <vs-button
      v-if="isResourceContent"
      id="back-to-topic_btn"
      @click="backToTeacherResources"
      icon-pack="feather"
      icon="icon-arrow-left"
      class="float-left mb-3 school-primary_gradient glow-effect_tertiary">
      Back
    </vs-button>
    <vs-button
      v-else
      id="back-to-topic_btn"
      @click="backToTopic"
      icon-pack="feather"
      icon="icon-arrow-left"
      class="float-left mb-3 school-primary_gradient glow-effect_tertiary">
      Back
    </vs-button>

    <div class="main-div">
      <div class="vx-row limit-width_fixed-scalable">
        <div style="margin:auto" class="mb-4">
          <vx-card class="glow-effect_bg-color__blend card__no-padding bg-color" style="width: 400px">
            <vx-input-group>
              <vs-button
                :disabled="true"
                size="large"
                style="width: 400px; padding-right: 0 !important;"
                class="button__fully-opaque glow-effect_bg-color__blend header_button-lookalike text__school-font-color bg-color"
                type="filled"
                color="">
                Adding Podcast
              </vs-button>
            </vx-input-group>
          </vx-card>

          <vx-card card-background="#11193f" class="glow-effect_dark height_uploader limit-width_uploader card__no-padding">
            <vx-input-group>
              <template slot="prepend">
                <div class="prepend-text height_uploader input-group_prepend-slot-bg">
                  <span><feather-icon class="pt-1" icon="UploadCloudIcon" svg-classes="stroke-current"></feather-icon></span>
                </div>
              </template>

              <file-pond
                id="filepond"
                ref="pond"
                :server="uploadLocation"
                label-idle="Drop audio here or <span class='filepond--label-action'>Browse</span>"
                :allow-multiple="false"
                accepted-file-types="audio/*"
                :instant-upload="true"
                allowPaste=false
                :allow-image-preview="true"
                @addfilestart="beforeUpload"
                @processfilestart="startUpload"
                @processfileprogress="uploadProgress"
                @processfile="uploadComplete"
                @removefile="fileRemoved"
              />
            </vx-input-group>
          </vx-card>
        </div>
      </div>

      <div>
        <div class="vx-row" id="podcastdetails">
          <div class="vx-col pb-3 w-full sm:w-1/2 md:w-1/2">
            <label style="color:rgb(202, 202, 202);">Title of podcast</label>
            <vs-input autocomplete="off" id="podcastname" class="w-full" v-model="podcastName"/>
          </div>
          <div class="vx-col w-full sm:w-1/2 md:w-1/2">
            <label class="pl-4" style="color:rgb(202, 202, 202);">Description of podcast</label>
            <vs-textarea id="podcastDesc" class="" v-model="podcastDesc" />
          </div>
        </div>
      </div>

    </div>

    <locations
      :isLocationViewActive="isLocationViewActive && !isResourceContent"
      :selectedData="selectedData"
      :uploadedFileUrl="uploadedFileUrl"
      @save="save"
    />

    <div v-if="isResourceContent" class="vx-row mt-5" id="add-location-button">
      <vs-spacer></vs-spacer>
      <div class="vx-col w-1/3 xs:w-full sm:w-3/5 md:w-2/5 lg:w-2/5 xl:w-1/5">
        <vx-card class="mb-3 glow-effect_dark card__no-padding bg-color">
          <vx-input-group>
            <template slot="prepend">
              <div class="prepend-text glow-effect_dark input-group_prepend-slot-bg">
                <span><feather-icon class="pt-1" icon="SaveIcon" svg-classes="stroke-current"></feather-icon></span>
              </div>
            </template>

            <vs-button
              :disabled="!uploadedFileUrl"
              size="large"
              class="w-full button-text__left-align glow-effect_primary school-primary_gradient"
              style="border-radius:0 7px 7px 0"
              @click="saveWithoutLocations">
              Save
            </vs-button>
          </vx-input-group>
        </vx-card>
      </div>
    </div>

  </div>
</template>

<script>
import vueFilePond from 'vue-filepond';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview);

import Locations from './Locations.vue';
export default {
  components: {
    FilePond,
    Locations
  },
  data() {
    return {
      isLocationViewActive: true,
      myFile: [],
      podcastName: "",
      podcastDesc: "",
      selectedData: {},
      uploadedFileUrl: null,
      activePrompt: false,
      numberOfTasks: null,
      isTeacher: false,
      isResourceContent: false
    };
  },
  computed: {
    uploadLocation: {
      get() {
        return this.$buildUrl("tempupload");
      }
    },
  },
  methods: {
    initValues() {
      var self = this;
      self.podcastName = "";
      self.podcastDesc = "";
      self.uploadedFileUrl = "";
    },
    beforeUpload(file) {
      
    },
    startUpload(file) {
      
    },
    uploadProgress(file, progress) {
      
    },
    uploadComplete(error, file) {
      var response = JSON.parse(file.serverId);
      if(response.url)
        this.uploadedFileUrl = response.url;
    },
    fileRemoved(error, file) {
      this.initValues();
    },
    save(allLocations) {
      var self = this;
      if(self.podcastName && self.podcastDesc) {
        self.showLoadingOnElement('maindiv', 1, 'material');

        var podcastToAddInfo = {
          name: self.podcastName,
          description: self.podcastDesc,
          uploadedFileName: self.uploadedFileUrl,
          modules: allLocations,
          number: self.numberOfTasks + 1,
          isPodcast: true
        };

        var onSuccess = response => {
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: `Podcast saved & added to ${allLocations.length} location(s).`,
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-save'
          });
          self.backToTopic();
        };
        var onFinally = function (){
          self.$vs.loading.close(self.$refs.maindiv.$el);
        };

        self.$ajaxPost(self, "Music", podcastToAddInfo, onSuccess, onFinally);
      }
      else {
        self.$vs.notify({
          title:'Warning',
          color: "warning",
          text: "Please ensure that you have entered a name AND a description for the podcast.",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-info',
          time: 5500
        });
      }
    },
    saveWithoutLocations() {
      var self = this;
      if(self.podcastName && self.podcastDesc) {
        self.showLoadingOnElement('maindiv', 1, 'material');

        var podcastToAddInfo = {
          name: self.podcastName,
          description: self.podcastDesc,
          uploadedFileName: self.uploadedFileUrl,
          modules: [],
          number: self.numberOfTasks + 1,
          isPodcast: true
        };

        podcastToAddInfo.modules.push(self.selectedData.selectedResource.topicId);

        var onSuccess = response => {
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: `Podcast saved`,
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-save'
          });
          self.backToTeacherResources();
        };
        var onFinally = function (){
          self.$vs.loading.close(self.$refs.maindiv.$el);
        };

        self.$ajaxPost(self, "Music", podcastToAddInfo, onSuccess, onFinally);
      }
      else {
        self.$vs.notify({
          title:'Warning',
          color: "warning",
          text: "Please ensure that you have entered a name AND a description for the podcast.",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-info',
          time: 5500
        });
      }
    },
    backToTopic() {
      var self = this;
      self.$vs.loading.close(self.$refs.maindiv.$el);
      if (self.isTeacher)
        self.$router.push({ name: 'TeacherBrowseContent', params: { selectedData: self.selectedData, navFromAddContent: true }});  
      else
        self.$router.push({ name: 'BrowseContent', params: { selectedData: self.selectedData, navFromAddContent: true }});
    },
    backToTeacherResources() {
      var self = this;
      self.$vs.loading.close(self.$refs.maindiv.$el);
      self.$router.push({ name: 'TeacherResources'});
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    }
  },
  mounted() {
    var self = this;
    self.initValues();

    self.selectedData = self.$route.params.selectedData;
    self.numberOfTasks = self.$route.params.numberOfTasks;
    self.isTeacher = self.$route.params.isTeacher;
    self.isResourceContent = self.$route.params.isResourceContent;
  }
};
</script>

<style lang="scss">
.main-div {
  width: 65%;
}

@media screen and (max-width: 900px) {
  .main-div {
    width: 100%;
  }
}

.filepond--panel-root {
  border-radius: 0 6px 6px 0;
  background-color: rgba(255, 255, 255, 0) !important;
}

.filepond--drop-label {
  color:rgb(202, 202, 202) !important;
}

#podcastname.vs-input--input {
  background: none !important;
  border: 5px solid rgba(192, 196, 212, 0.2) !important;
  border-radius: 20px !important;
  height: 55px !important;
  font-size: 1.4rem !important;
  color: rgb(202, 202, 202) !important;
}

#podcastDesc.vs-textarea {
  background: rgba(var(--vs-background),1) !important;
  border-radius: 20px !important;
  border: 5px solid rgba(192, 196, 212, 0.2) !important;
  color: rgb(202, 202, 202) !important;
  font-size: 1rem !important;
  height: 90px !important;
}

// #podcastdetails .vs-con-input-label {
//   width: 400px !important;
// }

#podcastdetails .focusx.vs-textarea-primary {
  border: 0 solid rgba(0, 0, 0, 0) !important;
}

#podcastdetails .vs-textarea-primary {
  border: 0 solid rgba(0, 0, 0, 0) !important;
}

.save__btn {
  border-radius: 15px !important;
}

#back-to-topic_btn {
  border-radius: 15px !important;
}
</style>
